import { useEffect } from 'react'
import { get } from 'lodash'
import { ModalBody, ModalHeader, Button } from 'reactstrap'
import { useDispatch, useSelector } from 'react-redux'
import NumberInput from 'react-number-format'

import { optionsSendLinkMethod } from './constants'
import RadioButton from '../../../common-components/radio-button-group'
import { getInsured, getCitizenId, getPassport } from 'e-submission/domain/data-model/form/selectors'
import { getCurrentApp } from '../../apps/selectors'
import { setSendLinkTextInput, setSendLinkMethod } from '../../apps/actions'
import createTextInput from '../../components/Form/Input/TextInput'
import { Modal } from '../../../common-components'
import { renderErrorMessage } from 'common-components/view-logic'
import { validateSendLinkInputPopup } from '../../domain/data-model/form/validation'

const TextInput = createTextInput(({ value, onChange }) => {
  return {
    value,
    onChange,
  }
})
const SendLinkButton = (props) => {
  const { onExit, isInvalid, handlerCreateCaseEkyc } = props
  return (
    <div style={{ textAlign: 'center' }}>
      <Button
        color={isInvalid ? 'disabled' : 'primary'}
        className="primary"
        onClick={() => {
          handlerCreateCaseEkyc()
          onExit()
        }}
      >
        ยืนยัน
      </Button>
    </div>
  )
}
export const _SendEkycLinkPopup = (props) => {
  const { insuredOrPayer, isOpen, openModal, onExit, handlerCreateCaseEkyc } = props

  const dispatch = useDispatch()
  const app = useSelector((state) => getCurrentApp(state))
  const insuredInfo = getInsured(app)
  const insuredId = getCitizenId('insured')(app)
  const payerId = getCitizenId('payer')(app)
  const insuredEmail = get(insuredInfo, 'email', '')
  const insuredMobileNo = get(insuredInfo, 'mobileNumber', '')
  const textInput = get(app, ['ekycInfo', 'sendLink', 'textInput'], insuredMobileNo)
  const method = get(app, ['ekycInfo', 'sendLink', 'method'], 'sms')
  const validateInput = validateSendLinkInputPopup({ textInput }, method)
  const options = optionsSendLinkMethod
  const citizenId = { insured: insuredId, payer: payerId }
  const insuredPassport = getPassport('insured')(app)
  const payerIdPassport = getPassport('payer')(app)
  const passportNumber = { insured: insuredPassport, payer: payerIdPassport }

  const setTextInput = (e) => {
    dispatch(setSendLinkTextInput('ekycInfo.sendLink.textInput', e))
  }
  const setMethod = (e) => {
    dispatch(setSendLinkMethod('ekycInfo.sendLink.method', e))
  }

  useEffect(() => {
    setTextInput(insuredMobileNo)
  }, [insuredMobileNo])

  useEffect(() => {
    if (method === 'sms') {
      setTextInput(insuredMobileNo)
    } else {
      setTextInput(insuredEmail)
    }
  }, [method])

  useEffect(() => {
    if (!isOpen) {
      setMethod('sms')
    }
  }, [isOpen])

  const isInvalid = validateInput && !validateInput.isOk
  return (
    <Modal
      isOpen={isOpen}
      size="md"
      modalClassName="default-bootstrap remote-selling-modal"
      toggle={() => {
        onExit()
      }}
    >
      <ModalHeader
        toggle={() => {
          onExit()
        }}
      >
        ส่งลิงก์ให้ผู้ขอเอาประกันเพื่อยืนยันตัวตน
      </ModalHeader>
      <ModalBody>
        กรุณาเลือกช่องทางการส่งลิงก์เพื่อยืนยันตัวตน
        <div className={`form-group ${isInvalid ? 'has-danger' : ''}`}>
          <RadioButton options={options} value={method} onChange={(e) => setMethod(e)} />
          {method === 'email' ? (
            <TextInput value={textInput} setValue={setTextInput} />
          ) : (
            <NumberInput
              value={textInput}
              format={'##########'}
              onChange={(e) => setTextInput(e.target.value)}
              className="form-control"
            />
          )}
          {!isInvalid ? null : renderErrorMessage('validate-method-error-message')(validateInput, 'VALIDATION')}
          <div
            style={{ minWidth: '100%' }}
            className="validation-message attached-icon info-message-wrap form-control-feedback"
          >
            <p>ท่านสามารถเลือกช่องทางในการส่งลิงก์ผ่านทางช่องทางที่ท่านต้องการ</p>
          </div>
        </div>
        <SendLinkButton
          onExit={() => onExit()}
          openModal={() => openModal()}
          isInvalid={isInvalid}
          handlerCreateCaseEkyc={() => handlerCreateCaseEkyc(citizenId[insuredOrPayer], passportNumber[insuredOrPayer])}
        />
      </ModalBody>
    </Modal>
  )
}

const SendEkycLinkPopup = _SendEkycLinkPopup

export default SendEkycLinkPopup
